import { render, staticRenderFns } from "./TemplateCadence.vue?vue&type=template&id=d245f2ee&scoped=true&"
import script from "./TemplateCadence.vue?vue&type=script&lang=ts&"
export * from "./TemplateCadence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d245f2ee",
  null
  
)

export default component.exports